export default __webpack_public_path__ + "static/media/document.3859ae93.svg";